import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Article from '@src/pc/index/components/Article';
import styles from './index.css';
import { formatImage } from '@ifeng-fe/public_method';
import { getThumbnail } from '@src/common/utils';

class ArticleBox extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;
        const extra = content.length % 3 === 0 ? 0 : 3 - content.length % 3;

        for (let i = 0; i < extra; i++) {
            content.push(undefined);
        }

        return (
            <div className={styles.articleBox}>
                {
                    content.map((data, index) => {
                        const { source, title, summary, url } = data || {};

                        return data
                            ? <Article key={index} source={source} image={formatImage(getThumbnail(data), 320 * 2, 180 * 2)} summary={summary} title={title} url={url} />
                            : <div key={index} style={{ width: '320px' }} />;
                    })
                }
            </div>
        );
    }
}

export default ArticleBox;
